module.exports = __webpack_public_path__ + "./PK_65c70edca976a4d9194c0cc05bf73078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/PK.jpg
// module id = 500
// module chunks = 0